import { api } from '../axios.helper';
import { Config, ProgrammeThemeDayDto } from '@ecdlink/core';
import { ProgrammeThemeDto } from '@ecdlink/core';
class ContentProgrammeThemeService {
  _accessToken: string;

  constructor(accessToken: string) {
    this._accessToken = accessToken;
  }

  async getProgrammeThemes(locale: string): Promise<ProgrammeThemeDto[]> {
    const apiInstance = api(Config.graphQlApi, this._accessToken);
    const response = await apiInstance.post<any>(``, {
      id: 'GetAllTheme',
      variables: {
        locale: locale,
      },
    });

    if (response.status !== 200) {
      throw new Error('Get Programme themes Failed - Server connection error');
    }

    return response.data.data.allThemesV2.map(
      (t: any) =>
        ({
          id: t.id,
          name: t.name,
          color: t.color,
          imageUrl: this.resolveThemeImageUrl(t.imageUrl),
          themeDays: t.themeDays.map(
            (td: any) =>
              ({
                id: td.id,
                day: td.day,
                largeGroupActivity: { id: td.largeGroupActivityId },
                smallGroupActivity: { id: td.smallGroupActivityId },
                storyActivity: { id: td.storyActivityId },
                storyBook: { id: td.storyBookId },
              } as unknown as ProgrammeThemeDayDto)
          ),
        } as ProgrammeThemeDto)
    );
  }

  private resolveThemeImageUrl(imageUrl?: string): string {
    if (!imageUrl) return '';

    const trimmed = imageUrl.trim();
    if (!trimmed) return '';

    if (trimmed.startsWith('data:image')) return trimmed;

    const normalisedPath = trimmed.replace(/\\/g, '/');

    // Keep already-absolute URLs while ensuring unsafe characters are encoded.
    if (/^https?:\/\//i.test(normalisedPath)) return encodeURI(normalisedPath);

    // Resolve relative file paths against the API host so routes do not break image lookups.
    if (Config.graphQlApi) {
      try {
        return new URL(encodeURI(normalisedPath), Config.graphQlApi).toString();
      } catch {
        return encodeURI(normalisedPath);
      }
    }

    return encodeURI(normalisedPath);
  }
}

export default ContentProgrammeThemeService;
